var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoumoniPartnerCupole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "38px",
    viewBox: "0 0 123 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0339480445 6.65253861 0.0339480445 6.65253861 19.0297802 0 19.0297802"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-132.000000, -33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(132.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#F24A3D",
    points: "46 38 52 38 52 10 46 10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0376729,19.0926406 L58.0376729,0.202146731 C60.9104808,0.262095347 64.054259,4.03234941 64.5545521,7.99992007 C65.2250947,13.3153069 62.5716768,17.9119954 58.0376729,19.0926406",
    id: "Fill-2",
    fill: "#F24A3D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.171282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65253861,0.0339480445 L6.65253861,19.0297802 C2.59809109,17.8602683 0.0460910891,14.1470511 0.00060990099,9.64234085 C-0.0481821782,4.80979732 2.80911683,1.1226149 6.65253861,0.0339480445",
    id: "Fill-4",
    fill: "#F24A3D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8705584,12.7747074 L16.8705584,19.331887 L9.91716436,19.331887 C12.2602297,17.1225236 14.649299,14.869312 16.8705584,12.7747074",
    id: "Fill-7",
    fill: "#F24A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1325814,0.0497573508 L16.8378329,0.0497573508 L16.8378329,6.99266343 C14.5038289,4.5760491 12.2503319,2.24233514 10.1325814,0.0497573508",
    id: "Fill-9",
    fill: "#F24A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.292065,19.1375507 L81.292065,0.152166714 C84.267162,0.383739652 87.4393442,4.2029803 87.8396135,7.99892663 C88.4076927,13.3857379 85.8424491,17.8263888 81.292065,19.1375507",
    id: "Fill-11",
    fill: "#F24A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1659232,0.08337996 L75.1659232,19.0060748 C72.0942875,18.835992 68.7933291,14.5402455 68.5317687,10.6346788 C68.1496222,4.92671424 71.1829212,1.18574936 75.1659232,0.08337996",
    id: "Fill-13",
    fill: "#F24A3D"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#F24A3D",
    points: "93 29 99 29 99 0 93 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(103.000000, 10.000000)",
    fill: "#F24A3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84746903,0.086159292 L6.84746903,19.712531 C3.74357522,19.431115 0.486584071,15.3739469 0.140566372,11.331823 C-0.332707965,5.80385841 2.04074336,1.72438938 6.84746903,0.086159292",
    id: "Fill-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8486726,10.1789735 L13.24,10.1789735 L13.24,0.16499115 C17.4674336,1.19985841 20.1773451,5.5699469 19.8486726,10.1789735",
    id: "Fill-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8877345,13.0874867 L19.8877345,19.8929735 L13.078,19.8929735 C15.3466726,17.6258938 17.6349912,15.3388142 19.8877345,13.0874867",
    id: "Fill-21"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#F24A3D",
    points: "34 30 40 30 40 10 34 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0010077,10 L28,10 L28,29.9880341 C25.3058641,30.1747318 22.7865752,28.1564407 22.2030412,25.353308 C22.1129524,24.9203472 22.0109583,24.4779625 22.0095368,24.0394896 C21.995677,19.3999627 22.0010077,14.7604359 22.0010077,10",
    id: "Fill-25",
    fill: "#F24A3D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoumoniPartnerCupole);
export default __webpack_public_path__ + "static/media/youmoni-partner-cupole.0c006ce69df3adef1c2ced8935daa9d0.svg";
export { ForwardRef as ReactComponent };